"use client";
'use strict';

var React = require('react');

const SelectedLocationContext = React.createContext(undefined);
const SelectedLocationProvider = SelectedLocationContext.Provider;

exports.SelectedLocationContext = SelectedLocationContext;
exports.SelectedLocationProvider = SelectedLocationProvider;
//# sourceMappingURL=SelectedLocationProvider.js.map
